// exerciseChatStore.ts
import { create } from 'zustand';

interface Message {
  text: string;
  isBot: boolean;
  role: "system" | "user" | "assistant";
  timestamp: Date;
  isError?: boolean;
}

interface ExerciseChatState {
  messages: Message[];
  addMessage: (message: Message) => void;
  addUserMessage: (text: string) => void;
  addAssistantMessage: (text: string, isError?: boolean) => void;
  getFormattedHistory: (limit?: number) => { role: "user" | "assistant" | "system", content: string }[];
  clearMessages: () => void;
}

export const useExerciseChatStore = create<ExerciseChatState>((set) => ({
  messages: [],
  addMessage: (message) =>
    set((state) => ({
      messages: [
        ...state.messages,
        {
          ...message,
          isBot: message.role === "assistant",
          timestamp: message.timestamp || new Date(),
        },
      ],
    })),
  addUserMessage: (text) => {
    const { addMessage } = useExerciseChatStore.getState();
    addMessage({
      text,
      isBot: false,
      role: "user",
      timestamp: new Date(),
    });
  },
  addAssistantMessage: (text, isError) => {
    const { addMessage } = useExerciseChatStore.getState();
    addMessage({
      text,
      isBot: true,
      role: "assistant",
      timestamp: new Date(),
      isError,
    });
  },
  getFormattedHistory: (limit = 10) => {
    const state = useExerciseChatStore.getState();
    return state.messages.slice(-limit).map((m) => ({
      role: m.role,
      content: m.text,
    }));
  },
  clearMessages: () => set({ messages: [] }),
}));

export default useExerciseChatStore;
